import { PERMISSIONS, type Permission } from './permissions';
import { useEffectiveRole } from './useRole';

export function useCan(permission: Permission): boolean {
  const role = useEffectiveRole();
  if (role === null) return false;
  const allowed = PERMISSIONS[permission] as readonly string[];
  return allowed.includes(role);
}
